import http from "../http-common";

class AreaN2DataService {
  getAll() {
    return http.get("/arean2");
  }

  getCondition(condition) {
    return http.get(`/arean2/search/?desc=${condition}`);
  }

  getAreaN2ByDescr(condition, sortfield,sorttype,arean1id = null) {
    return http.get(`/arean2/search/?nombrearea=${condition}&sortfield=${sortfield}&sorttype=${sorttype}&arean1id=${arean1id}`);
  }  

  get(id) {
    return http.get(`/arean2/${id}`);
  }

  create(data) {
    return http.post("/arean2/newarean2", data);
  }

  update(id, data) {
    return http.put(`/arean2/${id}`, data);
  }

  delete(id) {
    return http.delete(`/arean2/${id}`);
  }

  deleteAll() {
    return http.delete(`/arean2`);
  }

  findById(id) {
    return http.get(`/arean2?id=${id}`);
  }
}

export default new AreaN2DataService();